<div class="side-inner">
  <!-- <div class="side-modal-backdrop" (click)="goBack()"></div> -->
  <button title="close form" class="close-popup-button close-button modal-close" (click)="goBack()">close</button>
  <!-- <button role="button" title="close form" class="close-side-popup primary icon-button" (click)="goBack()"><fa-icon [icon]="faTimesIcon"></fa-icon></button> -->
  <lib-support-request-form  id="requestContainer" (closeForm)="goBack()"></lib-support-request-form>
</div>
